import { combineReducers } from "@reduxjs/toolkit";
import modalError from "./modalErrorSlice";
import loadingComponent from "./loadingSlice";
import modalAttachment from "./modalAttachmentSlice";
import toast from "./toastSlice";
import trackingDialog from "./trackingDialogSlice";
import exportCSVComponent from "./exportCSVSlice";
import menuLayout from "./menuLayoutSlice";

const trackingReducers = combineReducers({
  modalError,
  loadingComponent,
  modalAttachment,
  toast,
  trackingDialog,
  exportCSVComponent,
  menuLayout,
});

export default trackingReducers;
